import { render, staticRenderFns } from "./PlanByFleetCategory.vue?vue&type=template&id=24578e96&scoped=true"
import script from "./PlanByFleetCategory.vue?vue&type=script&lang=js"
export * from "./PlanByFleetCategory.vue?vue&type=script&lang=js"
import style0 from "./PlanByFleetCategory.vue?vue&type=style&index=0&id=24578e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24578e96",
  null
  
)

export default component.exports